import Role from './index.vue';
import RouteView from "../../router/RouteView.vue";
import Detail from "./Detail.vue";

export default [
  {
    path: '/role',
    name: 'Role',
    component: RouteView,
    redirect: '/role/list',
    meta: {
      title: '角色权限'
    },
    children: [
      {
        path: '/role/list',
        name: 'Role2',
        component: Role,
        meta: {
          title: '角色列表'
        }
      },
      {
        path: '/role/detail/:id/:name',
        name: 'Detail',
        component: Detail,
        meta: {
          title: '角色详情'
        },
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/views/Role/index.js